import { RootState } from '../../../applicationStore';
import { TypeOfPaymentsState } from '../reducers';
import { createSelector } from '@reduxjs/toolkit';

export const getTypeOfPaymentsState = (state: RootState): TypeOfPaymentsState =>
  state.typeOfPayments;

export const getTypeOfPaymentsLoader = createSelector(
  getTypeOfPaymentsState,
  (state): boolean => state.loading,
);

export const getTypeOfPaymentsData = createSelector(
  getTypeOfPaymentsState,
  (state): TypeOfPaymentsState['data'] | null => state?.data || [],
);
